import type { IconProps } from "./thumba-coin";

export const CalendarIcon = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none" {...props}>
    <g clipPath="url(#clip0_12879_22939)">
      <path
        d="M6.27832 4.71106H3.27832C3.07941 4.71106 2.88864 4.79008 2.74799 4.93073C2.60734 5.07138 2.52832 5.26215 2.52832 5.46106V15.9611C2.52832 16.16 2.60734 16.3507 2.74799 16.4914C2.88864 16.632 3.07941 16.7111 3.27832 16.7111H15.2783C15.4772 16.7111 15.668 16.632 15.8087 16.4914C15.9493 16.3507 16.0283 16.16 16.0283 15.9611V5.46106C16.0283 5.26215 15.9493 5.07138 15.8087 4.93073C15.668 4.79008 15.4772 4.71106 15.2783 4.71106H14.5283"
        stroke="#5C5C5C"
        strokeWidth="0.818182"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.52881 4.71106H12.2788"
        stroke="#5C5C5C"
        strokeWidth="0.818182"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.27832 3.21112V6.21112"
        stroke="#5C5C5C"
        strokeWidth="0.818182"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2783 3.21112V6.21112"
        stroke="#5C5C5C"
        strokeWidth="0.818182"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.52832 8.8363H13.0283"
        stroke="#5C5C5C"
        strokeWidth="0.818182"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_12879_22939">
        <rect width="18" height="18" fill="white" transform="translate(0.27832 0.960999)" />
      </clipPath>
    </defs>
  </svg>
);
